import React, { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { AuthContext } from "../../store/AuthProvider";
import { AppContext } from "../../store";

// `feature` is a tenant feature flag key (e.g. "fti"), the route is blocked unless it is active
export const ProtectedRoute = ({
  allowedRoute,
  feature,
  showOnStoreAdmin = true,
}) => {
  const { pathname } = useLocation();
  const isStoreAdmin = pathname.includes("store-admin");
  const { auth } = useContext(AuthContext);
  const { appState } = useContext(AppContext);

  let allowed = true;
  const hasPermission = auth?.data?.permissions?.find((item) =>
    allowedRoute?.includes(item.name)
  );
  if (!hasPermission) {
    allowed = false;
  }
  if (isStoreAdmin) {
    if (showOnStoreAdmin) {
      allowed = true;
    } else {
      allowed = false;
    }
    if (!hasPermission) {
      allowed = false;
    }
  }
  if (feature && !appState.features?.[feature]?.active) {
    allowed = false;
  }

  const isFeaturePending =
    feature && auth?.data?.id && !appState.isFeaturesFetched;

  return (
    !auth.isInitialLoad &&
    !isFeaturePending &&
    (allowed ? (
      <Outlet />
    ) : auth?.data?.id ? (
      <Navigate
        to={isStoreAdmin ? "/store-admin/unauthorized" : "/unauthorized"}
        replace
      />
    ) : (
      <Navigate to="/authentication/login" replace />
    ))
  );
};
